import React from 'react';
import ILink from '../../../types/ILink';
import KeywordDeletable, { KeywordDeletableProps } from './partials/KeywordDeletable';
import { Keyword } from './partials/Keyword';
import { KeywordsListContainer } from './partials/KeywordsListContainer';

type KeywordsEditableList = {
  keywords: Keyword[] | KeywordDeletableProps[];
  ariaLabel?: string; // only required when user actively adds keywords
};

const isILink = (item: ILink | KeywordDeletableProps): item is ILink => 'url' in item;

export function KeywordsEditableList({ keywords, ariaLabel }: KeywordsEditableList) {
  if (!keywords || keywords?.length === 0) {
    return null;
  }

  const keywordsListItems = keywords.map(keyword =>
    isILink(keyword) ? (
      <Keyword key={keyword.name} keyword={keyword} />
    ) : (
      <KeywordDeletable key={keyword.name} onClick={keyword.onClick} name={keyword.name} />
    )
  );

  return <KeywordsListContainer ariaLabel={ariaLabel}>{keywordsListItems}</KeywordsListContainer>;
}
